import React, { Component } from 'react'
import i18n from 'i18next'
import moment from 'moment'
import { observer } from 'mobx-react'

import Search from '../../Search'
import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'
import DistributionNavigation from '../DistributionNavigation'
import CreateEmailModal from './CreateEmailModal'
import TestEmailModal from './TestEmailModal'
import SurveyLinkWarningModal from './SurveyLinkWarningModal'
import UploadConfirmationModal from './UploadConfirmationModal'
import EmailListModal from './EmailListModal'
import CreateUserModal from './CreateUserModal'
import PreviewModal from './PreviewModal'
import DownloadModal from './DownloadModal'
import ErrorModal from './ErrorModal'
import OptOutLinkWarningModal from './OptOutLinkWarningModal'
import ScheduleEmailModal from './ScheduleEmailModal'
import SendNowModal from './SendNowModal'
import VerificationWarningModal from './VerificationWarningModal'
import Panel from '../../../UniformComponents/Panel'
import DataTable from '../../DataTable'
import ScheduleStatusLabel from './ScheduleStatusLabel'
import SendFromWarningModal from './SendFromWarningModal'
import Checkbox from '../../form/Checkbox'
import Typography from '../../../UniformComponents/Typography'
import EmailListMergeFieldModal from './EmailListMergeFieldModal'
import CreateEmailListModal from './CreateEmailListModal'
import DistributeEmptyState from '../../../UniformComponents/DistributeEmptyState'
import Tooltip from '../../../UniformComponents/Tooltip'
import Anchor from '../../../UniformComponents/Anchor'
import EmailListWarningModal from './EmailListWarningModal'
import DeleteSelectedModal from './DeleteSelectedModal'
import DeleteListModal from './DeleteListModal'
import DeleteUsersFromListModal from './DeleteUsersFromListModal'
import DeleteUsersFromListConfirmationModal from './DeleteUsersFromListConfirmationModal'
import ListStatusLabel from './ListStatusLabel'

const StatusLabel = ({ status, optout }) => {
    if (optout === 1) {
        return (
        // <div className="email-list-status-label optout">
        //     <p>{i18n.t('distributionEmailList.optoutstatus')}</p>

            <i className="far fa-user-minus" />
            // </div>
        )
    }
    const labels = []

    switch (status) {
        case 'co':
            labels.push(
                <Anchor cssClass="icon-link-btn">
                    <Tooltip
                        text={i18n.t('completed')}
                        direction="bottom"
                    />

                    <i className="far fa-circle-check" />
                </Anchor>
            )
            break
        case 'ex':
            labels.push(
                <Anchor cssClass="icon-link-btn">
                    <Tooltip
                        text={i18n.t('screened')}
                        direction="bottom"
                    />

                    <i className="far fa-circle-chevron-down" />
                </Anchor>
            )
            break
        case 'st':
            labels.push(
                <Anchor cssClass="icon-link-btn">
                    <Tooltip
                        text={i18n.t('dropped')}
                        direction="bottom"
                    />

                    <i className="far fa-ban" />
                </Anchor>
        
            )
            break

        case 'processing':
            labels.push(
                <div className="email-list-status-label dropped">
                    <p>{i18n.t('distributionEmailList.droppedStatus')}</p>
                </div>
            )
            break
        default:
            null

    }

    if (optout === 1) {
        labels.push(
             <Anchor cssClass="icon-link-btn">
                <Tooltip
                    text={i18n.t('optedout')}
                    direction="bottom"
                />

                <i className="far fa-user-minus" />
            </Anchor>
        )
    }

    return labels
}

@observer
class EmailBuilder extends Component {
    constructor(props) {
        super(props)

        const { distributeStore } = props

        if (distributeStore.isRapidSurvey() && !distributeStore.isRapidEmailsEnabled()) {
            distributeStore.goToCampaignLinks()
        }
    }

    componentDidMount() {
        const { distributeStore, tab } = this.props
        distributeStore.init(tab)
    }

    listHasBeenSent = (listname) => {
        const { distributeStore } = this.props
        const schedulesThatUseList = distributeStore.scheduleList.filter((list) => list.listname.includes(listname))

        if (!schedulesThatUseList) return false

        const schedulesThatHaveBeenSent = schedulesThatUseList.filter((list) => list.schedulestatus === 'complete')

        return schedulesThatHaveBeenSent.length > 0
    }

    getColumns = () => [
        {
            key: 'emailsubject',
            name: i18n.t('distributionEmailBuilder.emailSubject'),
            dataTransform: (value, row) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => (row.schedulestatus === 'completed' ? this.props.distributeStore.viewSchedule(row) : this.props.distributeStore.editSchedule(row))}
                >
                    {row.copiedschedulename && <strong style={{ opacity: 0.4 }}>Copy - </strong>}
                    <strong>{value}</strong>
                </div>
            ),
        },
        {
            key: 'senddatetime',
            name: i18n.t('distributionEmailBuilder.scheduledSendDate'),
            dataTransform: (value, row) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => (row.schedulestatus === 'completed' ? this.props.distributeStore.viewSchedule(row) : this.props.distributeStore.editSchedule(row))}
                >
                    {value
                        ? moment(value).tz(this.props.distributeStore.store.timeZone).format('Do MMM YYYY - HH:mm z')
                        : ''}
                </div>
            ),
        },
        {
            key: 'listname',
            name: i18n.t('s_tab_users'),
            dataTransform: (value, row) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => (row.schedulestatus === 'completed' ? this.props.distributeStore.viewSchedule(row) : this.props.distributeStore.editSchedule(row))}
                >
                    {value.join(', ')}
                </div>
            ),
        },
        {
            key: 'countemailsent',
            name: i18n.t('no_sent'),
            dataTransform: (value, row) => (
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => (row.schedulestatus === 'completed' ? this.props.distributeStore.viewSchedule(row) : this.props.distributeStore.editSchedule(row))}
                >
                    {value}
                </div>
            ),
        },
        {
            key: 'schedulestatus',
            name: '',
            dataTransform: (value) => (
                <ScheduleStatusLabel status={value} />
            ),
        },
        {
            key: '',
            name: '',
            dataTransform: (value, row) => (
                <div className="campaign-links-table-actions">
                    <Anchor
                        cssClass="icon-link-btn"
                        onClick={() => {
                            row.schedulestatus === 'completed'
                                ? this.props.distributeStore.copySchedule(row)
                                : this.props.distributeStore.editSchedule(row)
                        }}
                    >
                        <Tooltip
                            text={
                                row.schedulestatus === 'completed'
                                    ? i18n.t('distributionEmailBuilderModal.viewSchedule')
                                    : i18n.t('distributionEmailBuilderModal.editSchedule')
                            }
                            direction="bottom"
                        />

                        <i className={row.schedulestatus === 'completed' ? 'fal fa-eye' : 'fal fa-pen-to-square'} />
                    </Anchor>

                    <Anchor
                        cssClass="icon-link-btn"
                        onClick={() => this.props.distributeStore.copySchedule(row)}
                    >
                        <Tooltip
                            text={i18n.t('distributionEmailBuilderModal.copySchedule')}
                            direction="bottom"
                        />

                        <i className="fal fa-copy" />
                    </Anchor>
                </div>
            ),
        },
    ]

    getUserColumns = () => [
        {
            key: 'checked',
            name: '',
            dataTransform: (value, row) => (
                <Checkbox
                    key={`cb_${value}`}
                    onBlur={(e) => this.props.distributeStore.selected(e, row)}
                    checked={this.props.distributeStore.selectedUsers.includes(row.surveyuserid_txt)}
                />
            ),
            cellClass: 'center w50 select',
        },
        {
            key: 'firstname',
            name: i18n.t('user.form.firstName'),
            dataTransform: (value) => (
                <span className="email-list-status">{value}</span>
            ),
        },
        {
            key: 'lastname',
            name: i18n.t('user.form.lastName'),
            dataTransform: (value) => (
                <span className="email-list-status">{value}</span>
            ),
        },
        {
            key: 'email',
            name: i18n.t('sch_landing_schedule'),
            dataTransform: (value) => (
                <span className="email-list-status"><strong>{value}</strong></span>
            ),
        },
        {
            key: 'sdstatus',
            name: i18n.t('sch_email_status'),
            headerClass: 'center',
            cellClass: 'center',
            dataTransform: (value, row) => (
                <div style={{ display: 'flex', gap: 6 }}>
                    <StatusLabel status={value} optout={row.optout} />
                </div>
            ),
        },
        {
            key: 'listname',
            name: i18n.t('sch_userfield_list_name'),
            dataTransform: (value) => (
                <span className="email-list-status">{value}</span>
            ),
        },
        {
            key: 'campaignId',
            name: '',
            dataTransform: (_, row) => (
                <div className="campaign-links-table-actions">
                    <Anchor
                        cssClass="icon-link-btn"
                        onClick={(e) => this.props.distributeStore.editUser(e, row)}
                    >
                        <Tooltip
                            text={i18n.t('distributionEmailBuilderModal.editRespondent')}
                            direction="bottom"
                        />

                        <i className="fal fa-edit" />
                    </Anchor>
                </div>
            ),
            cellClass: 'center w50 pointer',
        },
    ]

    getListColumns = () => [
        {
            key: 'listname',
            name: i18n.t('sch_userfield_list_name'),
            dataTransform: (value) => (
                <span className="email-list-status">{value}</span>
            ),
        },
        {
            key: 'usercount',
            name: i18n.t('no_recipients'),
            dataTransform: (value) => (
                <span className="email-list-status"><strong>{value}</strong></span>
            ),
        },
        {
            key: 'listname',
            name: i18n.t('sch_email_list_columns_email_status'),
            dataTransform: (value) => (
                <ListStatusLabel status={this.listHasBeenSent(value) ? 'sent' : 'unsent'} />
            ),
        },
        {
            key: 'verifyState',
            name: i18n.t('sch_email_list_columns_verification_status'),
            dataTransform: (value) => (
                <ListStatusLabel status={value} />
            ),
        },
        {
            key: '',
            name: '',
            dataTransform: (value, row) => (
                <div className="campaign-links-table-actions">
                    <Anchor
                        cssClass="icon-link-btn"
                        onClick={() => this.props.distributeStore.showDeleteUsersFromListModal(row)}
                    >
                        <Tooltip
                            text={i18n.t(row.usercount !== 0 ? 'delete_contacts' : 'delete_list')}
                            direction="bottom"
                        />

{console.log('listID', this.props.distributeStore.scheduleList)}

                        <i className="fal fa-circle-xmark" />
                    </Anchor>
                </div>
            ),
        },
    ]

    render() {
        const { store, distributeStore } = this.props

        return (
            <div className="email-landing-content">
                <DistributionNavigation store={distributeStore} survey={store.survey} />

                <div className="email-landing-right-container">
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>{i18n.t('email')}</h2>

                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Button
                                    cssClass="regular tertiary"
                                    onClick={distributeStore.showCreateEmailModal}
                                    icon="fal fa-envelope"
                                    label={i18n.t('distributionEmailBuilder.create')}
                                />

                                <Button
                                    cssClass="regular tertiary"
                                    onClick={distributeStore.showEmailListModal}
                                    icon="fal fa-envelope"
                                    label={i18n.t('distributionEmailList.upload')}
                                />
                            </div>
                        </div>
                    </Panel>
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex' }}>
                            <div
                                className="email-builder-tab"
                                onClick={() => distributeStore.handleChangeTab('builder')}
                            >
                                <h4>{i18n.t('distributionEmailBuilder.manageEmails')}</h4>

                                {distributeStore.activeTab === 'builder'
                                    && (
                                        <div className="email-builder-active-tab" />
                                    )}
                            </div>

                            <div
                                className="email-builder-tab"
                                onClick={() => distributeStore.handleChangeTab('listusers')}
                            >
                                <h4>{i18n.t('distributionEmailBuilder.manageEmailRecipients')}</h4>

                                {distributeStore.activeTab === 'listusers'
                                    && (
                                        <div className="email-builder-active-tab" />
                                    )}
                            </div>

                            <div
                                className="email-builder-tab"
                                onClick={() => distributeStore.handleChangeTab('lists')}
                            >
                                <h4>{i18n.t('distributionEmailBuilder.manageEmailLists')}</h4>

                                {distributeStore.activeTab === 'lists'
                                    && (
                                        <div className="email-builder-active-tab" />
                                    )}
                            </div>
                        </div>

                        {distributeStore.activeTab === 'builder'
                            && (
                                <div>
                                    {!distributeStore.scheduleList.length
                                        ? (
                                            <DistributeEmptyState
                                                title={i18n.t('distributionEmailBuilder.emptyStateText')}
                                                subtext={i18n.t('distributionEmailBuilder.emptyStateSubText')}
                                                ctaText={i18n.t('sch_email_add')}
                                                icon="fal fa-envelope-open-text"
                                                ctaIcon="fal fa-envelope-open-text"
                                                onClick={distributeStore.showCreateEmailModal}
                                            />
                                        )
                                        : (
                                            <div>
                                                <div style={{
                                                    display: 'flex', gap: 20, marginTop: 30, marginBottom: 20,
                                                }}
                                                >
                                                    <Select
                                                        elClass="email-landing-select"
                                                        defaultValue={distributeStore.defaultStatusFilter.value}
                                                        options={distributeStore.statusFilterOptions}
                                                        onBlur={distributeStore.changeStatusFilter}
                                                        label={i18n.t('distributionEmailBuilder.showingList')}
                                                        isClearable
                                                        blurOnClear
                                                    />

                                                    <Search
                                                        ref={(s) => { distributeStore.listsSearchModule = s }}
                                                        onSearch={distributeStore.searchLists}
                                                        searchOnBlur
                                                        cssClass="email-landing-search"
                                                        label={i18n.t('search')}
                                                    />
                                                </div>

                                                <DataTable
                                                    store={distributeStore}
                                                    dataSet={distributeStore.filteredListList}
                                                    columns={this.getColumns()}
                                                    cssClass="email-landing-data-table"
                                                    inMemory
                                                />
                                            </div>
                                        )}
                                </div>
                            )}

                        {distributeStore.activeTab === 'listusers'
                            && (
                                <div>
                                    {!distributeStore.userList.length
                                        && !distributeStore.selectedEmailList.value
                                        && !distributeStore.statusFilters.length
                                        && !distributeStore.invalid
                                        && !distributeStore.userFilterText.length
                                        && !distributeStore.optedOut
                                        ? (
                                            <DistributeEmptyState
                                                title={i18n.t('distributionEmailList.emptyStateText')}
                                                subtext={i18n.t('distributionEmailList.emptyStateSubText')}
                                                ctaText={i18n.t('distributionEmailList.upload')}
                                                icon="fal fa-envelope-open-text"
                                                ctaIcon="fal fa-envelope-open-text"
                                                onClick={distributeStore.showEmailListModal}
                                            />
                                        )
                                        : (
                                            <div>
                                                <div className="email-builder-upload-stats">
                                                    <div className="email-builder-stats-header">
                                                        <i className="fas fa-circle-info" />

                                                        <Typography type="p" color="secondary">
                                                            {i18n.t('sch_stats_label')}
                                                        </Typography>
                                                    </div>

                                                    <div className="email-builder-stats-container">
                                                        <div>
                                                            <Typography type="p">
                                                                {i18n.t('sch_stats_total')}
                                                            </Typography>

                                                            <Typography type="h4">
                                                                {distributeStore.totalCount}
                                                            </Typography>
                                                        </div>

                                                        <div>
                                                            <Typography type="p">
                                                                {i18n.t('sch_stats_optout')}
                                                            </Typography>

                                                            <Typography type="h4">
                                                                {distributeStore.optOutCount}
                                                            </Typography>
                                                        </div>

                                                        <div>
                                                            <Typography type="p">
                                                                {i18n.t('sch_stats_non_verified')}
                                                            </Typography>

                                                            <Typography type="h4">
                                                                {distributeStore.invalidCount}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="email-builder-lists-inputs">
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                        <Select
                                                            label={i18n.t('s_tab_users')}
                                                            options={distributeStore.emailListOptions}
                                                            onBlur={distributeStore.listViewOnChangeList}
                                                            cssClass="email-list-filter"
                                                            isClearable
                                                            blurOnClear
                                                        />

                                                        <Search
                                                            ref={(s) => { distributeStore.userSearchModule = s }}
                                                            onSearch={distributeStore.searchUsers}
                                                            searchOnBlur
                                                            cssClass="email-landing-search"
                                                            label={i18n.t('search')}
                                                        />
                                                    </div>

                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                        <Button
                                                            label={i18n.t('distributionEmailList.addUser')}
                                                            icon="far fa-user-plus"
                                                            cssClass="regular tertiary"
                                                            onClick={distributeStore.showCreateUserModal}
                                                        />

                                                        <Button
                                                            label={i18n.t('distributionEmailList.exportOptions')}
                                                            icon="far fa-folder-arrow-down"
                                                            cssClass="regular tertiary"
                                                            onClick={distributeStore.showDownloadModal}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="email-builder-lists-filters">
                                                    <p>{i18n.t('report_filters')}</p>

                                                    <Checkbox
                                                        label={i18n.t('completed')}
                                                        onBlur={() => distributeStore.onListFilterChange('co')}
                                                        name="completed"
                                                    />

                                                    <Checkbox
                                                        label={i18n.t('screened')}
                                                        onBlur={() => distributeStore.onListFilterChange('ex')}
                                                        name="screened"
                                                    />

                                                    <Checkbox
                                                        label={i18n.t('dropped')}
                                                        onBlur={() => distributeStore.onListFilterChange('st')}
                                                        name="dropped"
                                                    />

                                                    <Checkbox
                                                        label={i18n.t('notStarted')}
                                                        onBlur={() => distributeStore.onListFilterChange('ns')}
                                                        name="notStarted"
                                                    />

                                                    <Checkbox
                                                        label={i18n.t('optedout')}
                                                        onBlur={distributeStore.onOptedOutChange}
                                                        value={distributeStore.optedOut}
                                                        name="optedOut"
                                                    />

                                                    <Checkbox
                                                        label={i18n.t('notValidEmail')}
                                                        onBlur={distributeStore.onInvalidChange}
                                                        value={distributeStore.invalid}
                                                        name="notValidEmail"
                                                    />
                                                </div>

                                                {!!distributeStore.selectedUsers.length
                                                    && (
                                                        <div style={{
                                                            display: 'flex', alignItems: 'center', gap: '16px', marginBottom: 20,
                                                        }}
                                                        >
                                                            <Button
                                                                icon="far fa-trash-can"
                                                                label={i18n.t('delete')}
                                                                cssClass="regular secondary"
                                                                onClick={distributeStore.showDeleteSelectedModal}
                                                            />

                                                            <Typography>
                                                                {`(${distributeStore.selectedUsers.length} selected)`}
                                                            </Typography>
                                                        </div>
                                                    )}
                                                <div style={{ position: 'relative' }}>
                                                    <Checkbox
                                                        checked={distributeStore.selectAll}
                                                        onBlur={distributeStore.toggleSelectAll}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '20px',
                                                            left: '20px',
                                                        }}
                                                    />

                                                    <DataTable
                                                        store={distributeStore}
                                                        dataSet={distributeStore.userList}
                                                        columns={this.getUserColumns()}
                                                        cssClass="email-landing-data-table"
                                                        loadRecords={distributeStore.getUsers}
                                                        recordCount={distributeStore.rowCount}
                                                        showPagination
                                                    />
                                                </div>
                                            </div>
                                        )}
                                </div>
                            )}

                        {distributeStore.activeTab === 'lists'
                            && (
                                <div>
                                    {!distributeStore.emailList.length
                                        ? (
                                            <DistributeEmptyState
                                                title={i18n.t('distributionEmailList.emptyStateText')}
                                                subtext={i18n.t('distributionEmailList.emptyStateSubText')}
                                                ctaText={i18n.t('distributionEmailList.upload')}
                                                icon="fal fa-envelope-open-text"
                                                ctaIcon="fal fa-envelope-open-text"
                                                onClick={distributeStore.showEmailListModal}
                                            />
                                        ) : (
                                            <div>
                                                <br />

                                                <Search
                                                    ref={(s) => { distributeStore.userSearchModule = s }}
                                                    onSearch={distributeStore.searchUsers}
                                                    searchOnBlur
                                                    cssClass="email-landing-search"
                                                    label={i18n.t('search')}
                                                />

                                                <br />

                                                <DataTable
                                                    store={distributeStore}
                                                    dataSet={distributeStore.emailList}
                                                    columns={this.getListColumns()}
                                                    cssClass="email-landing-data-table"
                                                    inMemory
                                                />
                                            </div>
                                        )}
                                </div>
                            )}
                    </Panel>

                    <br />
                </div>

                <CreateEmailModal
                    distributeStore={distributeStore}
                    store={store}
                />

                <TestEmailModal distributeStore={distributeStore} />

                <SurveyLinkWarningModal distributeStore={distributeStore} />

                <OptOutLinkWarningModal distributeStore={distributeStore} />

                <ScheduleEmailModal distributeStore={distributeStore} />

                <SendNowModal distributeStore={distributeStore} />

                <VerificationWarningModal distributeStore={distributeStore} />

                <SendFromWarningModal distributeStore={distributeStore} />

                <EmailListModal distributeStore={distributeStore} />

                <CreateUserModal distributeStore={distributeStore} />

                <PreviewModal distributeStore={distributeStore} />

                <UploadConfirmationModal distributeStore={distributeStore} />

                <DownloadModal distributeStore={distributeStore} />

                <EmailListMergeFieldModal distributeStore={distributeStore} />

                <CreateEmailListModal distributeStore={distributeStore} />

                <EmailListWarningModal distributeStore={distributeStore} />

                <DeleteSelectedModal distributeStore={distributeStore} />

                <DeleteListModal distributeStore={distributeStore} />

                <DeleteUsersFromListModal distributeStore={distributeStore} />

                <DeleteUsersFromListConfirmationModal distributeStore={distributeStore} />

                <ErrorModal distributeStore={distributeStore} />
            </div>
        )
    }
}

export default observer(EmailBuilder)
